<template>
  <div class="form-item-container">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="response-container">
      <div v-for="(image, index) in images" :key=index class="rate-img">
        <img :src="image.currentSrc" @click="handleImageClick(index)" alt="Face image" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import FaceRate4 from '@/assets/icons/Rate4.svg'
import FaceRate3 from '@/assets/icons/Rate3.svg'
import FaceRate2 from '@/assets/icons/Rate2.svg'
import FaceRate1 from '@/assets/icons/Rate1.svg'

import FaceRate4Clicked from '@/assets/icons/Rate4ok.svg'
import FaceRate3Clicked from '@/assets/icons/Rate3ok.svg'
import FaceRate2Clicked from '@/assets/icons/Rate2ok.svg'
import FaceRate1Clicked from '@/assets/icons/Rate1ok.svg'

export default defineComponent({
  name: 'RatingFaces',
  props: {
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      faceRatingStates: [
        { original: FaceRate1, clicked: FaceRate1Clicked },
        { original: FaceRate2, clicked: FaceRate2Clicked },
        { original: FaceRate3, clicked: FaceRate3Clicked },
        { original: FaceRate4, clicked: FaceRate4Clicked }
      ],
      images: [] as { currentSrc: string }[],
      FaceRate4,
      FaceRate3,
      FaceRate2,
      FaceRate1
    }
  },
  created () {
    console.log('form_item_id: ', this.form_item_id)
    this.images = this.faceRatingStates.map(image => ({ currentSrc: image.original }))
  },
  methods: {
    handleImageClick (index: number) {
      this.images.forEach((image, i) => {
        image.currentSrc = this.faceRatingStates[i].original
      })
      this.images[index].currentSrc = this.faceRatingStates[index].clicked
    }
  }
})
</script>

<style scoped>
.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  padding: 2em 5% 2em 5%;

  color: white;

  .questions-container {
    grid-row: 1;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;

    align-items: center;
    justify-items: center;

    padding-bottom: 2em;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

  .response-container {
    display: flex;
    gap: 2em;
    justify-content: center;
    padding: 1em 0em;

    .rate-img {
      display: inline-block;
      width: 15%;
      margin-top: 1%;
      text-align: center;

      img {
        width: 5em;
        cursor: pointer;
        object-fit: cover;
      }
    }
  }
}

@media (max-width: 1024px) {
  .form-item-container {
    .response-container {
      display: flex;
      gap: 2em;
      justify-content: center;
      padding: 1em 0em;

      div img {
        /* width: 120px; */
        max-width: 100%;
      }
    }
  }
}
</style>
